import { COLORS } from './theme'
import type { RsvpStatus } from './types'

/**
 * Single source of truth for the semantic colour of a hunt-invitation answer.
 *
 * CLUB-580 — a declined answer used to render in the primary (green) tone on
 * some surfaces, the same colour as an acceptance, so a decline read as an
 * acceptance at a glance. Every surface that shows an RSVP state now reads its
 * colours from here, so the three states cannot drift apart again.
 *
 * The mapping mirrors the mobile app, which is the reference implementation
 * (`rsvp_status_button_widget.dart` / `participants_content_widget.dart`):
 *
 *   accepted → colorScheme.primary            (positive, green)
 *   rejected → colorScheme.error              (negative, red)
 *   pending  → onSurface @ 60%                (neutral, muted)
 *
 * `fg` is the label colour and `bg` the chip fill; each pair clears 4.5:1 in
 * both the light and dark token sets. Labels stay with the call site because
 * they differ per surface (2nd-person "You declined" vs roster "Declined").
 */
export const RSVP_COLORS: Record<RsvpStatus, { fg: string; bg: string }> = {
  pending: { fg: COLORS.onSurfaceVariant, bg: COLORS.surfaceContainerHighest },
  accepted: { fg: COLORS.primary, bg: COLORS.primaryOpacity12 },
  declined: { fg: COLORS.error, bg: COLORS.errorContainer },
}
